import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import PageCoupons from 'Pages/coupons';
import PageCoupon from 'Pages/coupon';

const Home = ({ match }) => (
	<div className="dashboard-wrapper">
		<Switch>
			<Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
			<Route exact path={`${match.url}/list`} component={PageCoupons} />
			<Route exact path={`${match.url}/create`} component={PageCoupon} />
			<Route exact path={`${match.url}/edit/:couponId`} component={PageCoupon} />
			<Redirect to="/error" />
		</Switch>
	</div>
);
export default Home;
